import {
  addPictureLibrary,
  deletePictureLibrary,
  queryPictureLibraryById,
  queryPictureLibraryList,
  updatePictureLibrary,
  updateDownloadNum,
  updateUseNum,
  getTags,
  addTag,
  deleteTag,
} from '../requests';

const initPagination = {
  pageSize: 20,
  currentPage: 1,
  total: 0,
};

const Model = {
  namespace: 'pictureLibrary',
  state: {
    tabledData: [],
    pagination: initPagination,
    detail: null,
  },
  effects: {
    *queryPictureLibraryList({ payload }, { call, put }) {
      const res = yield call(queryPictureLibraryList, payload);
      if (res && res.code === 0) {
        yield put({ type: 'savePictureLibraryList', payload: res.data });
      }
      return res;
    },
    *queryPictureLibraryById({ payload }, { call, put }) {
      const res = yield call(queryPictureLibraryById, payload);
      if (res && res.code === 0) {
        yield put({ type: 'savePictureLibraryDetail', payload: res.data });
      }
      return res;
    },
    *addPictureLibrary({ payload }, { call }) {
      return yield call(addPictureLibrary, payload);
    },
    *updatePictureLibrary({ payload }, { call }) {
      return yield call(updatePictureLibrary, payload);
    },
    *deletePictureLibrary({ payload }, { call }) {
      return yield call(deletePictureLibrary, payload);
    },
    *updateDownloadNum({ payload }, { call }) {
      return yield call(updateDownloadNum, payload);
    },
    *updateUseNum({ payload }, { call }) {
      return yield call(updateUseNum, payload);
    },
    *getTags({ payload }, { call }) {
      return yield call(getTags, payload);
    },
    *addTag({ payload }, { call }) {
      return yield call(addTag, payload);
    },
    *deleteTag({ payload }, { call }) {
      return yield call(deleteTag, payload);
    },
  },
  reducers: {
    savePictureLibraryList(state, { payload }) {
      const { pageNum = 1, pageSize = 10, total = 0, dataInfos = [] } = payload || {};
      const pagination = {
        currentPage: pageNum,
        pageSize,
        total,
      };
      return { ...state, tabledData: dataInfos, pagination };
    },
    savePictureLibraryDetail(state, { payload }) {
      return { ...state, detail: payload || null };
    },
    clearPictureLibraryDetail(state) {
      return { ...state, detail: null };
    },
  },
};

export default Model;
